<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                model-def="tasks"
                model-class="task"
                :models="models"
                :infos="infos"
                :activities="true"
                :maillogs="false"
                :fileuploader="true">

                <template slot="relations">
                    <v-col class="pa-0 pb-4" v-if="thereIsChecklist">
                        <v-card class="flex pa-0 round-card background-2">
                            <v-card-title class="pa-3">
                                <p class="pl-2 pl-xl-3">Checklist</p>
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-container class="pa-0" fluid>
                                <v-row class="ma-0">
                                    <v-col class="col-xs-12 col-sm-12 col-md-6" v-for="(checklist, c) in relations.checklists.collection" :key="c">
                                        <v-list two-line class="background-2">
                                            <v-subheader>{{ checklist.name }}</v-subheader>
                                            <v-list-item v-for="(checklistitem, i) in checklist.checklistitems" :key="i">
                                                <v-list-item-action>
                                                    <v-icon color="primary">{{ checklistitem.done ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ checklistitem.name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'task',
        props: {
            id: Number,
        },
        data() {
            return {
                models: {},
                infos: {},
                relations: {},		
            }
        },

        computed: {

            thereIsChecklist() {
                return (this.relations && this.relations.checklists && this.relations.checklists.collection  && this.relations.checklists.collection.length > 0)
            }      

        },

        created() {
			this.axios.get('tasks/' + this.id + '?lite=1').then(response => {
                if(response.data.taskboard_url) {
                    this.$router.push(response.data.taskboard_url)
                } else {
                    this.getFullTask()
                }
            }, response => {
                // error callback
                this.getFullTask()
            })
        },

        methods: {
            getFullTask() {
                this.axios.get('tasks/' + this.id).then(response => {
                    this.models = response.data.models
                    this.infos = response.data.infos
                    this.relations = response.data.relations
                    this.$store.commit('endProgress')
                    
                }, response => {
                    // error callback
                })
            }
        }
    }
</script>